import { Tooltip } from "antd";
import { Info } from "lucide-react";
import styles from "./ProductBuilder.module.css";

/**
 * Label + aligned info bubble, optional count after.
 * Order: label · info · (count)
 */
export default function LabelWithInfo({
  label,
  hint,
  count,
  variant = "field",
  stopPropagation = false,
  className = "",
  as: Tag = "div",
}) {
  const rootClass = [
    styles.labelWithInfo,
    variant === "header" ? styles.labelWithInfoHeader : styles.labelWithInfoField,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const handleStop = stopPropagation
    ? (event) => {
        event.stopPropagation();
      }
    : undefined;

  return (
    <Tag className={rootClass}>
      <span className={styles.labelWithInfoText}>{label}</span>
      {hint ? (
        <Tooltip title={hint}>
          <span
            className={styles.labelWithInfoIcon}
            role="img"
            aria-label={typeof hint === "string" ? hint : "More information"}
            onClick={handleStop}
            onKeyDown={handleStop}
          >
            <Info size={12} aria-hidden />
          </span>
        </Tooltip>
      ) : null}
      {count != null && count !== "" ? (
        <span className={styles.labelWithInfoCount}>({count})</span>
      ) : null}
    </Tag>
  );
}
